import LoginForm from '../components/loginComponent/LoginForm'

const LoginPage = () => {
    return (
        <LoginForm />
    )
}

export default LoginPage
